import { generateID } from '@eventr/common'
import { Icon, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { editItineraryTranslation } from '../../../i18n/translateHelpers'
import { bs } from '../../../state/bound.store'
import { getUsersCommaSeparated } from '../../../state/user.slice'
import { ActivitiesBookingBody } from '../../../v2/components/activitiesBookingBody'
import { FormBookingCard } from '../formComponents/formBookingCard'
import { BaseBookingsListPage } from '../subPages/baseBookingsListPage'
import { ActivityValidationSchema } from './activityEditItem'
export const ActivitiesBookingsPage = () => {
    const { watch, setValue } = useFormContext<ActivityValidationSchema>()
    const nav = useNavigate()
    const name = watch('activity_name') || ''
    const attendees = watch('attendees_list') || []
    return (
        <BaseBookingsListPage
            title={editItineraryTranslation('Edit Attendees')}
            subHeaderText={name}
            addButtonText={editItineraryTranslation('Add Attendee List')}
            onNewItemPressed={() => {
                const newAttendee = {
                    _id: generateID(bs().selectedItinID, 8),
                }
                attendees.push(newAttendee)
                setValue('attendees_list', attendees, { shouldDirty: true })
                nav(newAttendee._id, { relative: 'path' })
            }}
        >
            <>
                {attendees.map((attendee: any, index: number) => {
                    const { users } = attendee

                    return (
                        <FormBookingCard
                            key={attendee?._id ?? 'new'}
                            motionKey={attendee?._id ?? 'new'}
                            hideChevron
                            openAtStart
                            header={
                                <Stack direction={'row'} spacing={'16px'}>
                                    <Icon name={'Activity'} />
                                    <Typography
                                        id={`${index}booking-ref-text`}
                                        noWrap
                                        overflow={'hidden'}
                                        textOverflow={'ellipsis'}
                                        maxWidth={'calc(100vw - 150px)'}
                                        variant={'bodyBold'}
                                    >
                                        {getUsersCommaSeparated(users as any)}
                                    </Typography>
                                </Stack>
                            }
                            index={index}
                            arrayName={'attendees_list'}
                        >
                            <ActivitiesBookingBody
                                id={index.toString()}
                                data={attendee as any}
                            />
                        </FormBookingCard>
                    )
                })}
            </>
        </BaseBookingsListPage>
    )
}
